import { forwardRef, type Ref, type SVGProps } from "react";
const IconDoubleChevronLeftFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <g fillRule="evenodd" clipRule="evenodd">
      <path d="M27.037 2.001a2 2 0 0 0-1.417.582l-12 12a2 2 0 0 0 0 2.83l12 12a2.001 2.001 0 0 0 2.83-2.83l-10.58-10.58 10.58-10.58a2 2 0 0 0 0-2.83 2 2 0 0 0-1.413-.592" />
      <path d="M16.964 2.001a2 2 0 0 0-1.417.582l-12 12a2 2 0 0 0 0 2.83l12 12a2.001 2.001 0 0 0 2.83-2.83l-10.58-10.58 10.58-10.58a2 2 0 0 0 0-2.83 2 2 0 0 0-1.413-.592" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(IconDoubleChevronLeftFilledSVG);
ForwardRef.displayName = "IconDoubleChevronLeftFilled";
export { ForwardRef as IconDoubleChevronLeftFilled };
